// extracted by mini-css-extract-plugin
module.exports = {"description":"blog-teaser-section-module--description--lL4AF"};